import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const latestArticles = [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, 6);

const articleImages: Record<string, string> = {
  'article-1': 'https://readdy.ai/api/search-image?query=Chinese%20website%20registration%20page%20on%20laptop%20screen%20with%20clean%20modern%20design%2C%20warm%20lighting%2C%20minimal%20interface%2C%20professional%20atmosphere&width=800&height=400&seq=article-1&orientation=landscape',
  'article-2': 'https://readdy.ai/api/search-image?query=Password%20reset%20security%20concept%20on%20a%20modern%20website%20interface%2C%20warm%20neutral%20tones%2C%20clean%20UI%20design%2C%20professional%20tech%20atmosphere&width=800&height=400&seq=article-2&orientation=landscape',
  'article-3': 'https://readdy.ai/api/search-image?query=Cybersecurity%20concept%20with%20shield%20icon%20on%20digital%20screen%2C%20warm%20professional%20atmosphere%2C%20clean%20modern%20design&width=800&height=400&seq=article-3&orientation=landscape',
  'article-4': 'https://readdy.ai/api/search-image?query=Digital%20platform%20features%20overview%20on%20a%20clean%20modern%20interface%2C%20warm%20professional%20design%2C%20multiple%20feature%20icons&width=800&height=400&seq=article-4&orientation=landscape',
  'article-5': 'https://readdy.ai/api/search-image?query=Search%20engine%20optimization%20concept%20on%20a%20digital%20screen%2C%20warm%20lighting%2C%20clean%20modern%20interface%2C%20professional%20design&width=800&height=400&seq=article-5&orientation=landscape',
  'article-6': 'https://readdy.ai/api/search-image?query=Official%20announcement%20on%20a%20website%20with%20megaphone%20icon%2C%20warm%20professional%20atmosphere%2C%20clean%20modern%20design&width=800&height=400&seq=article-6&orientation=landscape',
  'article-7': 'https://readdy.ai/api/search-image?query=Privacy%20policy%20and%20data%20protection%20concept%20on%20a%20digital%20screen%2C%20warm%20professional%20design%2C%20lock%20icon&width=800&height=400&seq=article-7&orientation=landscape',
  'article-8': 'https://readdy.ai/api/search-image?query=Terms%20of%20service%20document%20on%20a%20desk%20with%20warm%20lighting%2C%20professional%20legal%20atmosphere%2C%20clean%20modern%20design&width=800&height=400&seq=article-8&orientation=landscape',
  'article-9': 'https://readdy.ai/api/search-image?query=Troubleshooting%20guide%20concept%20on%20a%20laptop%20screen%2C%20warm%20professional%20atmosphere%2C%20question%20mark%20icon&width=800&height=400&seq=article-9&orientation=landscape',
  'article-10': 'https://readdy.ai/api/search-image?query=Phishing%20website%20warning%20concept%20with%20danger%20icon%20on%20digital%20screen%2C%20warm%20professional%20atmosphere&width=800&height=400&seq=article-10&orientation=landscape',
  'article-11': 'https://readdy.ai/api/search-image?query=Personalization%20settings%20interface%20on%20a%20modern%20website%2C%20warm%20professional%20design%2C%20clean%20and%20minimal&width=800&height=400&seq=article-11&orientation=landscape',
  'article-12': 'https://readdy.ai/api/search-image?query=Email%20verification%20concept%20on%20a%20laptop%2C%20warm%20professional%20atmosphere%2C%20envelope%20icon%2C%20modern%20design&width=800&height=400&seq=article-12&orientation=landscape',
};

export default function LatestArticles() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              最新文章推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-500">精选 91n.com 最新使用教程与平台资讯</p>
          </div>
          <Link
            to="/category/announcement"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all group cursor-pointer"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={articleImages[article.id]}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {article.readTime}
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">{article.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/announcement"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}